import { lazyGetAndUpdateAccessToken } from 'owa-headers-refresh-token';
import { orchestrator } from 'satcheljs';
import { retryAccountUpdateToken } from 'owa-accounts-store';

orchestrator(retryAccountUpdateToken, async ({ accountId, userIdentity, currentToken }) => {
    // wait for a new token to update
    await lazyGetAndUpdateAccessToken.importAndExecute(
        accountId,
        userIdentity,
        currentToken,
        true /* isRetry */
    );
});
